export default "<div>\r\n    This is your personal journal, you are the only one with access.\r\n</div>";